import _toConsumableArray from "C:\\PROJECTS2\\showtime\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";

/**
 * Gets all the DOM elements matching a selector
 * @param query - CSS selector string, HTML element, or an array of them
 */
export var getElements = function getElements(query) {
  if (!query) return [];
  var elements = [];

  if (typeof query === "string") {
    elements.push.apply(elements, _toConsumableArray(Array.prototype.slice.call(document.querySelectorAll(query))));
  } else if (Array.isArray(query)) {
    query.forEach(function (item) {
      if (typeof item === "string") {
        elements.push.apply(elements, _toConsumableArray(Array.prototype.slice.call(document.querySelectorAll(item))));
      } else {
        elements.push(item);
      }
    });
  } else {
    elements.push(query);
  }

  return elements;
};
var listening = [];
/**
 * Safely adds an event listener, preventing duplicates
 * @param element - HTML element to add event listener to
 * @param type - Type of event listener to add
 * @param fn - Callback function to call on event
 */

export var safeListen = function safeListen(element, type, fn) {
  var hasListener = !!listening.find(function (a) {
    return a.element === element && a.type === type;
  });
  if (hasListener) return;
  element.addEventListener(type, fn);
  listening.push({
    element: element,
    type: type
  });
};

var safeRequestAnimationFrame = function safeRequestAnimationFrame(callback) {
  if (window.requestAnimationFrame) return window.requestAnimationFrame(callback);
  setTimeout(function () {
    callback(0);
  }, 100);
};
/**
 *
 * @param image - An HTML <img> element in the DOM
 */


export var fitImageToContainer = function fitImageToContainer(params, image) {
  return new Promise(function (resolve) {
    safeRequestAnimationFrame(function () {
      var parent = image.parentElement;
      var currentDimensions = image.getBoundingClientRect();
      if (!parent) return;
      var dimensions = parent.getBoundingClientRect();

      if (currentDimensions.height < currentDimensions.width) {
        image.style.height = "".concat(dimensions.height, "px");
        image.style.width = "auto";
      } else {
        image.style.width = "".concat(dimensions.width, "px");
        image.style.height = "auto";
      }

      safeRequestAnimationFrame(function () {
        var currentDimensions = image.getBoundingClientRect();

        if (currentDimensions.height > dimensions.height) {
          image.style.height = "".concat(dimensions.height, "px");
          image.style.width = "auto";
        } else if (currentDimensions.width > dimensions.width) {
          image.style.width = "".concat(dimensions.width, "px");
          image.style.height = "auto";
        }

        safeRequestAnimationFrame(function () {
          var effect = params.uppload.container.querySelector(".uppload-effect");
          if (effect) effect.style.opacity = "1";
          resolve();
        });
      });
    });
  });
};
/**
 * Compress an image using lossy canvas compression
 * @param file - Image file to compress
 * @param settings - Uppload settings defined in the constructor
 */

export var compressImage = function compressImage(file, settings) {
  return new Promise(function (resolve) {
    var imageURL = URL.createObjectURL(file);
    var canvas = document.createElement("canvas");
    var image = document.createElement("img");
    var maxSize = settings.maxSize || [settings.maxWidth || Infinity, settings.maxHeight || Infinity];
    image.src = imageURL;

    image.onload = function () {
      var type = settings.compressionMime || "image/jpeg";
      var quality = settings.compression || 1;
      var ratio = image.width / image.height;

      if (image.width > maxSize[0]) {
        image.width = maxSize[0];
        image.height = image.width * (1 / ratio);
      }

      if (image.height > maxSize[1]) {
        image.height = maxSize[1];
        image.width = image.height * ratio;
      }

      canvas.width = image.width;
      canvas.height = image.height;
      var context = canvas.getContext("2d");
      if (!context) return resolve(file);
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      canvasToBlob(canvas, type, quality).then(function (blob) {
        if (blob) return resolve(blob);
        resolve(file);
      });
    };
  });
};
/**
 * Convert a data URI image string to Blob
 * @param dataURI - Data URI of image
 * @source https://stackoverflow.com/a/12300351/1656944
 */

var dataURItoBlob = function dataURItoBlob(dataURI) {
  var byteString = atob(dataURI.split(",")[1]);
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  var arrayBuffer = new ArrayBuffer(byteString.length);
  var uArray = new Uint8Array(arrayBuffer);

  for (var i = 0; i < byteString.length; i++) {
    uArray[i] = byteString.charCodeAt(i);
  }

  return new Blob([arrayBuffer], {
    type: mimeString
  });
};
/**
 * Export an HTML canvas to Blob image
 * @param canvas - Canvas element to export
 * @param type - MIME type of image
 * @param quality - Compression ratio (0 to 1)
 */


export var canvasToBlob = function canvasToBlob(canvas, type, quality) {
  return new Promise(function (resolve, reject) {
    if (typeof canvas.toBlob === "function") {
      canvas.toBlob(function (blob) {
        if (blob) resolve(blob);
        reject(new Error("errors.image_error"));
      }, type, quality);
    } else if (typeof canvas.toDataURL === "function") {
      var dataURI = canvas.toDataURL(type, quality);
      resolve(dataURItoBlob(dataURI));
    } else {
      reject(new Error("errors.image_error"));
    }
  });
};